interface ErrorPayload {
    code: string | number;
    data: any & object;
}

export const getErrorPayload = async (payload: unknown): Promise<ErrorPayload | Error> => {
    if (payload instanceof Error) {
        return payload;
    } else if (payload instanceof Response) {
        const { status: code } = payload;

        try {
            const data = await payload.json();
            return { code, data };
        } catch {
            return { code, data: {} };
        }
    } else if (typeof payload === 'string') {
        return new Error(payload);
    } else {
        return new Error(String(payload));
    }
};
